import { z } from 'zod';
import { FlowDynamicValueSchema } from './dynamicValue.js';
export const FlowArgumentSchema = z.object({
    id: z.string(),
    name: z.string(),
    value: FlowDynamicValueSchema,
});
//# sourceMappingURL=flowArgument.js.map